import { ID_CINEMOON } from '@cineamo/api/constants/cinema-ids';

import { pathnames } from '@/i18n/i18n.config';
import { usePathname } from '@/i18n/routing';

export const CINEMA_G_TAG_ID_MAP: Record<number, string | undefined> = {
    [ID_CINEMOON]: 'G-78YLX0VMLL'
};

export type ComponentAnalytics<T extends Record<string, string | number | undefined> = Record<string, string>> = {
    track?: {
        sourceName?: string;
    } & T;
};

export function usePageName(): string {
    const pathname = usePathname();
    return getPageNameFromPath(pathname);
}

export function getPageNameFromPath(path: string): string {
    return pathnames[path]?.pageName ?? path;
}
